import { CrossTabStore } from './store.svelte';
import {
  createBrowserChannelProvider,
  createBrowserLockProvider
} from './browser';

export type {
  CrossTabMessageType,
  CrossTabMessage,
  LockProvider,
  ChannelProvider,
  CrossTabDeps
} from './types';

export { CrossTabStore } from './store.svelte';
export {
  createBrowserChannelProvider,
  createBrowserLockProvider,
  MASTER_LOCK,
  BROADCAST_CHANNEL
} from './browser';

function generateTabId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `tab-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function createCrossTabStore(): CrossTabStore {
  const store = new CrossTabStore({
    tabId: generateTabId(),
    locks: createBrowserLockProvider(),
    channel: createBrowserChannelProvider()
  });
  store.init();
  return store;
}